import { render, staticRenderFns } from "./myInstance.vue?vue&type=template&id=2ff04d81&"
import script from "./myInstance.vue?vue&type=script&lang=js&"
export * from "./myInstance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports